
import { org } from '../types';

export const getOrgList = ({ limit, page, query, dropdown = false, type, vendors_from, get_verification_data, source, is_rma }) => ({
    type: org.GET_ORG_LIST_REQUEST,
    payload: { limit, page, query, dropdown, type, vendors_from, get_verification_data, source, is_rma }
});



export const resetOrgDropdownList = () => ({
    type: org.RESET_ORG_DROPDOWN_LIST
});


export const getOrgDetails = ({ orgId, callWalletDetails }) => ({
    type: org.GET_ORG_DETAIL_REQUEST,
    payload: { orgId, callWalletDetails }
});

export const getOrgContacts = ({ orgId, limit, page, query, dropdown }) => ({
    type: org.GET_ORG_CONTACTS_REQUEST,
    payload: { orgId, limit, page, query, dropdown }
});


export const getOrgEndUsers = ({ orgId, limit, page, query, dropdown }) => ({
    type: org.GET_ORG_END_USERS_REQUEST,
    payload: { orgId, limit, page, query, dropdown }
});


export const getOrgBranches = ({ orgId, limit, page, query, dropdown }) => ({
    type: org.GET_ORG_BRANCHES_REQUEST,
    payload: { orgId, limit, page, query, dropdown }
});


export const postEntities = ({ }) => ({
    type: org.POST_ENTITIES_REQUEST,
    payload: {}
})
